import { render, staticRenderFns } from "./indentity.vue?vue&type=template&id=5ea13011&scoped=true&"
import script from "./indentity.vue?vue&type=script&lang=ts&"
export * from "./indentity.vue?vue&type=script&lang=ts&"
import style0 from "./indentity.vue?vue&type=style&index=0&id=5ea13011&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea13011",
  null
  
)

export default component.exports